module.exports = __webpack_public_path__ + "static/img/after-cleaning2.70f00a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/after-cleaning2.png
// module id = +jdo
// module chunks = 1